/**
 * Frontend-local copy of the shared HTML sanitizer policy. Keep this in sync
 * with `backend/src/utils/sanitization/htmlSanitizerPolicy.ts`.
 */
export const htmlSanitizerPolicy = {
  extraAllowedTags: [
    "img",
    "video",
    "audio",
    "source",
    "track",
    "picture",
    "iframe",
    "embed",
    "object",
    "param",
    "figure",
    "figcaption",
    "section",
    "article",
    "aside",
    "main",
    "nav",
    "header",
    "footer",
    "time",
  ],
  extraAllowedAttributes: [
    "data-file-id",
    "target",
    "rel",
    "style",
    "class",
    "allow",
    "allowfullscreen",
    "frameborder",
    "referrerpolicy",
    "controls",
    "width",
    "height",
    "title",
    "alt",
    "loading",
  ],
  forbiddenTags: ["script"],
  fallbackIframeDomains: ["www.youtube.com", "youtube.com", "youtu.be", "player.vimeo.com", "vimeo.com", "codepen.io"],
} as const;

export type HtmlSanitizerPolicy = typeof htmlSanitizerPolicy;
